import type { LoginSuccessResponse } from '@/api/auth/auth.types'
import {
  buildHandoffUrl,
  sanitizeAdmindeskHandoffNext,
  sanitizeHandoffNext,
  sanitizeSuporteHandoffNext,
  type MainAppHandoffOptions,
} from '@imobdesk/auth-handoff'
import {
  resolveAdmindeskAppUrl,
  resolveMainAppUrl,
  resolveSuporteAppUrl,
} from '@imobdesk/env'
import { getImobdeskEnvRecord } from '@/lib/imobdesk-env-record'

export type { MainAppHandoffOptions }

export {
  sanitizeAdmindeskHandoffNext,
  sanitizeHandoffNext,
  sanitizeSuporteHandoffNext,
} from '@imobdesk/auth-handoff'

export function getMainAppBaseUrl(): string {
  const url = resolveMainAppUrl(getImobdeskEnvRecord())
  if (!url) {
    throw new Error('VITE_MAIN_APP_URL não configurada')
  }
  return url
}

export function getMainAppHandoffHref(
  tokens: Pick<LoginSuccessResponse, 'accessToken'>,
  options?: MainAppHandoffOptions,
): string {
  return buildHandoffUrl({
    baseUrl: getMainAppBaseUrl(),
    accessToken: tokens.accessToken,
    next: options?.next,
    sanitizeNext: sanitizeHandoffNext,
  })
}

/**
 * Envia o usuário para o app principal com tokens na query (rota /auth/handoff consome e limpa a URL).
 */
export function redirectMainAppHandoff(
  tokens: Pick<LoginSuccessResponse, 'accessToken'>,
  options?: MainAppHandoffOptions,
): void {
  window.location.href = getMainAppHandoffHref(tokens, options)
}

export function getSuporteAppBaseUrl(): string {
  return resolveSuporteAppUrl(getImobdeskEnvRecord())
}

export function getSuporteAppHandoffHref(
  tokens: Pick<LoginSuccessResponse, 'accessToken'>,
  options?: { next?: unknown },
): string {
  const base = getSuporteAppBaseUrl()
  if (!base) {
    throw new Error('VITE_SUPORTE_APP_URL não configurada')
  }
  return buildHandoffUrl({
    baseUrl: base,
    accessToken: tokens.accessToken,
    next: options?.next,
    sanitizeNext: sanitizeSuporteHandoffNext,
  })
}

export function getAdmindeskAppBaseUrl(): string {
  return resolveAdmindeskAppUrl(getImobdeskEnvRecord())
}

export function getAdmindeskAppHandoffHref(
  tokens: Pick<LoginSuccessResponse, 'accessToken'>,
  options?: { next?: unknown },
): string {
  const base = getAdmindeskAppBaseUrl()
  if (!base) {
    throw new Error('VITE_ADMINDESK_APP_URL não configurada')
  }
  return buildHandoffUrl({
    baseUrl: base,
    accessToken: tokens.accessToken,
    next: options?.next,
    sanitizeNext: sanitizeAdmindeskHandoffNext,
    defaultNext: '/admin',
  })
}
